import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { getProductCategoriesLazy } from '../../modules/products/actions';

import DesignerNavigationInfiniteScroll from './DesignerNavigationInfiniteScroll';
import styles from './DesignerNavigationInfiniteScroll.styles';

const mapStateToProps = ({ productsModule: { productCategory } }) => ({
  data: productCategory.data && productCategory.data[0],
  loading: productCategory.infiniteListLoading,
});

const mapDispatchToProps = {
  getProductCategoriesLazy,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  fetch: (params) => dispatchProps.getProductCategoriesLazy(params, ownProps.categoryId, ownProps.parentId, true),
});

export default compose(
  withStyles(styles),
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  ),
)(DesignerNavigationInfiniteScroll);
